module.exports = __webpack_public_path__ + "static/media/equality.c6931ffb.png";